<template>
  <div id="contenedor-configuracion-firmas-mobile"></div>
</template>

<script>
export default {
  name: 'ConfiguracionFirmasMobile',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
